import React, { useEffect } from "react";
import { setGlobalState, useGlobalState } from "../../globalStyle";
import axios from "axios";
const ConfigLoader = () => {

  useEffect(() => {
    let isMounted = true;

    const getConfig = async () => {
      try {
        const url = process.env.REACT_APP_CONFIG_URL;
        if (!url) {
          console.error("REACT_APP_CONFIG_URL is not defined");
          return;
        }

        const result = await axios.get(url, "GET");
        const configDetails = result?.data;

        if (!Array.isArray(configDetails)) {
          console.warn("Config data is not an array:", configDetails);
          return;
        }

        if (isMounted) {
          // Example for AUTHENTICATION
          // const AUTHENTICATION = configDetails.filter((c) => c.type === "AUTHENTICATION");
          // const authenticationUrl =
          //   AUTHENTICATION[0]?.link && AUTHENTICATION[0].link !== "" ? AUTHENTICATION[0].link : "";
          // setGlobalState("AUTHENTICATION", authenticationUrl);

          // Other config entries
          const PAYMENTBASEURL = configDetails.filter((c) => c.type === "PAYMENTBASEURL")[0]?.link || "";
          const ALLOWUSERSCRIPTURL = configDetails.filter((c) => c.type === "ALLOWUSERSCRIPTURL")[0]?.link || "";
          const PRODUCTMAINURL = configDetails.filter((c) => c.type === "PRODUCTMAINURL")[0]?.link || "";
          const VERIFYUSERS = configDetails.filter((c) => c.type === "VERIFYUSERS")[0]?.link || "";
          const AUTHORIZEREQURL = configDetails.filter((c) => c.type === "AUTHORIZEREQURL")[0]?.link || "";
          const SUBSCRIPTIONSTATUSCHECK = configDetails.filter((c) => c.type === "SUBSCRIPTIONSTATUSCHECK")[0]?.link || "";
          // const SECRETSETTLEMENTURL = configDetails.filter((c) => c.type === "SECRETSETTLEMENTURL")[0]?.link || "";
          // const CENTRALLOGGERURL = configDetails.filter((c) => c.type === "CENTRALLOGGERURL")[0]?.link || "";
          const LINKTRACKERURL = configDetails.filter((c) => c.type === "LINKTRACKERURL")[0]?.link || "";
          const BASEURL = configDetails.filter((c) => c.type === "BASEURL")[0]?.link || "";

          // // Set all other config in global state
          setGlobalState("PAYMENTBASEURL", PAYMENTBASEURL);
          setGlobalState("ALLOWUSERSCRIPTURL", ALLOWUSERSCRIPTURL);
          setGlobalState("PRODUCTMAINURL", PRODUCTMAINURL);
          setGlobalState("VERIFYUSERS", VERIFYUSERS);
          setGlobalState("AUTHORIZEREQURL", AUTHORIZEREQURL);
          setGlobalState("SUBSCRIPTIONSTATUSCHECK", SUBSCRIPTIONSTATUSCHECK);
          // setGlobalState("SECRETSETTLEMENTURL", SECRETSETTLEMENTURL);
          // setGlobalState("CENTRALLOGGERURL", CENTRALLOGGERURL);
          setGlobalState("LINKTRACKERURL", LINKTRACKERURL);
          setGlobalState("BASEURL", BASEURL);
        }
      } catch (error) {
        console.error("Error fetching config:", error);
      }
    };

    getConfig();

    return () => {
      isMounted = false;
    };

  }, [setGlobalState]);

  return null;
};

export default ConfigLoader;